import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PrivateRoutingQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type PrivateRoutingQuery = { __typename?: 'Query', privateRouting?: { __typename?: 'PrivateRoutingList', items: Array<{ __typename?: 'PrivateRouting', id: number, priority: number, comment?: string | null, gateway?: { __typename?: 'Gateway', id: number, lastCallDirection?: string | null, lastCallTime?: string | null, number?: { __typename?: 'Number', domainId: number } | null } | null, destination?: { __typename?: 'Destination', id: number, name: string } | null } | null> } | null };

export type GatewaysQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type GatewaysQuery = { __typename?: 'Query', gateways?: { __typename?: 'GatewayList', items: Array<{ __typename?: 'Gateway', id: number, displayName: string, lastCallTime?: string | null, lastCallDirection?: string | null, number?: { __typename?: 'Number', e164?: any | null } | null, callbackNumber?: { __typename?: 'Number', e164?: any | null } | null } | null> } | null };

export type DestinationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DestinationsQuery = { __typename?: 'Query', destination?: { __typename?: 'DestinationList', items: Array<{ __typename?: 'Destination', id: number, name: string } | null> } | null };


export const PrivateRoutingDocument = gql`
    query PrivateRouting($domainId: Int!) {
  privateRouting(domainId: $domainId) {
    items {
      id
      priority
      gateway {
        id
        lastCallDirection
        lastCallTime
        number {
          domainId
        }
      }
      destination {
        id
        name
      }
      comment
    }
  }
}
    `;

/**
 * __usePrivateRoutingQuery__
 *
 * To run a query within a React component, call `usePrivateRoutingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivateRoutingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivateRoutingQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function usePrivateRoutingQuery(baseOptions: Apollo.QueryHookOptions<PrivateRoutingQuery, PrivateRoutingQueryVariables> & ({ variables: PrivateRoutingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivateRoutingQuery, PrivateRoutingQueryVariables>(PrivateRoutingDocument, options);
      }
export function usePrivateRoutingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivateRoutingQuery, PrivateRoutingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivateRoutingQuery, PrivateRoutingQueryVariables>(PrivateRoutingDocument, options);
        }
export function usePrivateRoutingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrivateRoutingQuery, PrivateRoutingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrivateRoutingQuery, PrivateRoutingQueryVariables>(PrivateRoutingDocument, options);
        }
export type PrivateRoutingQueryHookResult = ReturnType<typeof usePrivateRoutingQuery>;
export type PrivateRoutingLazyQueryHookResult = ReturnType<typeof usePrivateRoutingLazyQuery>;
export type PrivateRoutingSuspenseQueryHookResult = ReturnType<typeof usePrivateRoutingSuspenseQuery>;
export type PrivateRoutingQueryResult = Apollo.QueryResult<PrivateRoutingQuery, PrivateRoutingQueryVariables>;
export const GatewaysDocument = gql`
    query Gateways($domainId: Int!) {
  gateways(domainId: $domainId) {
    items {
      id
      displayName
      lastCallTime
      lastCallDirection
      number {
        e164
      }
      callbackNumber {
        e164
      }
    }
  }
}
    `;

/**
 * __useGatewaysQuery__
 *
 * To run a query within a React component, call `useGatewaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatewaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatewaysQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useGatewaysQuery(baseOptions: Apollo.QueryHookOptions<GatewaysQuery, GatewaysQueryVariables> & ({ variables: GatewaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GatewaysQuery, GatewaysQueryVariables>(GatewaysDocument, options);
      }
export function useGatewaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GatewaysQuery, GatewaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GatewaysQuery, GatewaysQueryVariables>(GatewaysDocument, options);
        }
export function useGatewaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GatewaysQuery, GatewaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GatewaysQuery, GatewaysQueryVariables>(GatewaysDocument, options);
        }
export type GatewaysQueryHookResult = ReturnType<typeof useGatewaysQuery>;
export type GatewaysLazyQueryHookResult = ReturnType<typeof useGatewaysLazyQuery>;
export type GatewaysSuspenseQueryHookResult = ReturnType<typeof useGatewaysSuspenseQuery>;
export type GatewaysQueryResult = Apollo.QueryResult<GatewaysQuery, GatewaysQueryVariables>;
export const DestinationsDocument = gql`
    query Destinations {
  destination {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useDestinationsQuery__
 *
 * To run a query within a React component, call `useDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDestinationsQuery(baseOptions?: Apollo.QueryHookOptions<DestinationsQuery, DestinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationsQuery, DestinationsQueryVariables>(DestinationsDocument, options);
      }
export function useDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationsQuery, DestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationsQuery, DestinationsQueryVariables>(DestinationsDocument, options);
        }
export function useDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DestinationsQuery, DestinationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DestinationsQuery, DestinationsQueryVariables>(DestinationsDocument, options);
        }
export type DestinationsQueryHookResult = ReturnType<typeof useDestinationsQuery>;
export type DestinationsLazyQueryHookResult = ReturnType<typeof useDestinationsLazyQuery>;
export type DestinationsSuspenseQueryHookResult = ReturnType<typeof useDestinationsSuspenseQuery>;
export type DestinationsQueryResult = Apollo.QueryResult<DestinationsQuery, DestinationsQueryVariables>;